import React, { useState, useEffect } from "react";
import {
  XCircle,
  PencilSquare,
  ToggleOn,
  ToggleOff,
} from "react-bootstrap-icons";
import { toast } from "react-toastify";
import Axios from "../config/AxiosConfig";
import "react-toastify/dist/ReactToastify.css";

const Banners = () => {
  const [banners, setBanners] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchBanners();
  }, [page, searchQuery]);

  const fetchBanners = async () => {
    setLoading(true);
    try {
      const response = await Axios.get(`super-admin/premium-ads`, {
        params: { search: searchQuery, page, limit: 5 },
      });
      setBanners(response.data.adsImages);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching Ad Images:", error);
      setBanners([]);
    }
    setLoading(false);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchQuery("");
  };

  const toggleBannerStatus = async (adId, isEnabled) => {
    try {
      await Axios.put(`super-admin/toggle-status/${adId}`, {
        isEnabled: !isEnabled,
      });
      toast.success(
        `Ad Image ${!isEnabled ? "enabled" : "disabled"} successfully`
      );
      fetchBanners();
    } catch (error) {
      toast.error("Error updating Ad Image status");
    }
  };

  const updateFrequency = async (adId, newFrequency) => {
    try {
      await Axios.put(`super-admin/update-frequency/${adId}`, {
        frequency: newFrequency,
      });
      toast.success("Frequency updated successfully");
      fetchBanners();
    } catch (error) {
      toast.error("Error updating frequency");
    }
  };

  const updateBannerImage = async (adId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      await Axios.put(`super-admin/update-image/${adId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Ad image updated successfully");
      fetchBanners();
    } catch (error) {
      toast.error("Error updating banner image");
    }
  };

  return (
    <div className="banners-container">
      <h2>Ad Image Management</h2>

      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by Restaurant Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <XCircle
              className="clear-icon"
              size={18}
              onClick={handleClearSearch}
            />
          )}
        </div>
        <button onClick={() => setSearchQuery(searchTerm)}>Search</button>
      </div>

      <table className="banners-table">
        <thead>
          <tr>
            <th>SNo</th>
            <th>Image</th>
            <th>Restaurant</th>
            <th>Frequency</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
           <p>Loading Ad Images...</p>
          ) : banners.length > 0 ? (
            banners.map((banner, index) => (
              <tr key={banner._id}>
                <td>{index + 1 + (page - 1) * 5}</td>
                <td>
                  <img
                    src={`https://restaurantapi.nextdaysoft.com${banner.image}`}
                    alt="Ad"
                    className="banner-img"
                    onClick={() =>
                      setSelectedImage(
                        `https://restaurantapi.nextdaysoft.com${banner.image}`
                      )
                    }
                  />
                </td>
                <td>{banner.restaurant.restaurantName}</td>
                <td>
                  <input
                    type="number"
                    value={banner.frequency}
                    onChange={(e) =>
                      updateFrequency(banner._id, e.target.value)
                    }
                    className="frequency-input"
                  />
                </td>
                <td>
                  <button
                    className="status-toggle"
                    onClick={() =>
                      toggleBannerStatus(banner._id, banner.isEnabled)
                    }
                  >
                    {banner.isEnabled ? (
                      <ToggleOn size={26} color="green" />
                    ) : (
                      <ToggleOff size={26} color="red" />
                    )}
                  </button>
                </td>
                <td>
                  <label className="upload-icon" title="Update Ads Image">
                    <PencilSquare size={18} />
                    <input
                      type="file"
                      hidden
                      onChange={(e) => updateBannerImage(banner._id, e)}
                    />
                  </label>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No Ad Image found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="pagination">
        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
          Previous
        </button>
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={page === i + 1 ? "active" : ""}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>

      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full Ad" />
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banners;
